export enum ControlantAPIErrorType {
    CONTROLANT_API_ERROR_80,
    CONTROLANT_API_ERROR_81,
    CONTROLANT_API_ERROR_82,
    CONTROLANT_API_ERROR_83,
    CONTROLANT_API_ERROR_84,
    CONTROLANT_API_ERROR_85
}

export class ControlantAPIError extends Error {

    private _type: ControlantAPIErrorType;

    get type() {
        return this._type;
    }
    constructor(errorType: ControlantAPIErrorType, message: string = '') {
        super(message);
        this._type = errorType;
    }

}
